import { ChangeEvent, MouseEvent, useState } from 'react';
import { Calendar } from 'lucide-react';
import { useOfferPatch } from '@/services/useOfferPatch';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { TableRow, TableCell } from "@/components/ui/table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faPencil, faUpRightFromSquare, faMinus } from '@fortawesome/free-solid-svg-icons';
import { Offer } from '@/types/Offer';
import { Vel } from '@/types/Vel';

interface OfferRowProps {
  offer: Offer,
  vel: Vel,
  handleOfferSelection: (e: React.MouseEvent<HTMLButtonElement>, offer: Offer | null) => void;
}

function OfferRow({offer, vel, handleOfferSelection}: OfferRowProps) {
  const {mutate} = useOfferPatch({ offerId: offer.id, velId: vel.id })
  const [edit, editSet] = useState(false);
  const [value, valueSet] = useState(offer.title || '');
	const [expirationDate, setExpirationDate] = useState(offer.expirationDate || '');

  const goEdit = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    editSet(true);
  };

  const valueChange = (e: ChangeEvent<HTMLInputElement>) => valueSet(e.target.value);

  const save = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    mutate({title:value, expirationDate: new Date(expirationDate).toISOString()})
    editSet(false);
  }

  const rowClass = `${vel.offer === offer.id ? ' bg-muted' : ''}`;
  return (
    <TableRow className={rowClass}>
      <TableCell>{offer.id}</TableCell>
      <TableCell className="text-center">{vel.offer === offer.id && <strong><FontAwesomeIcon icon={faStar} /><br/>Bannière par défaut</strong>}</TableCell>
      <TableCell>
        {!edit && (
					<div className='mb-2'>
						<p>{offer.title || "[Pas de nom]"}</p>
						{offer.expirationDate && (
							<div className='flex items-center gap-1'>
								<Calendar className='w-4 h-4 text-muted-foreground' />
								<p className='text-muted-foreground'>Décompte jusqu'au:</p>
								<p>{new Date(offer.expirationDate)?.toLocaleDateString("fr-FR", { hour: '2-digit', minute: '2-digit', day: '2-digit', month: 'long'})}</p>
							</div>
						)}
						</div>
				)}
        {edit && (
					<div className='flex flex-col gap-2 mb-2'>
						<Input type='text' value={value} onChange={valueChange}/>
						{vel.offer === offer.id && (
							<div>
								<span className='text-sm text-gray-600'>Décompte jusqu'au:</span>
								<Input 
									type="datetime-local"
									name="expirationDate" 
									value={expirationDate} 
									onChange={e => setExpirationDate(e.target.value)} 
								/>
							</div>
							)}
						</div>
					)}
        {!edit && <Button variant='outline' size='sm' onClick={goEdit}><FontAwesomeIcon icon={faPencil} /> Modifier</Button>}
        {edit && <Button variant='outline' size='sm' onClick={save} >Enregistrer</Button>}
      </TableCell>
      <TableCell>
        <img width='600px' src={offer.url} />
        <p className='m-2'><FontAwesomeIcon icon={faUpRightFromSquare} /> <a href={offer.url} target='_blank'>{offer.url}</a></p>
      </TableCell>
      <TableCell>
        {vel.offer === offer.id && <Button variant='outline' onClick={ e => handleOfferSelection(e, null)}><FontAwesomeIcon icon={faMinus} /> Retirer</Button>}
        {vel.offer !== offer.id && <Button onClick={ e => handleOfferSelection(e, offer)}><FontAwesomeIcon icon={faStar} /> Utiliser</Button>}
      </TableCell>
    </TableRow>
  );
}

export default OfferRow;
